const GA_MEASUREMENT_ID = 'G-CLSP694ZPP';

(function () {
  const PRODUCT_CATALOG = {
    basic: { item_id: 'basic', item_name: 'Basic PC Optimization', item_category: 'package' },
    standard: { item_id: 'standard', item_name: 'Standard PC Optimization', item_category: 'package' },
    premium: { item_id: 'premium', item_name: 'Premium PC Optimization', item_category: 'package' },
    registrytweak: { item_id: 'registrytweak', item_name: 'Registry Tweaks Script', item_category: 'extra' },
    latency: { item_id: 'latency', item_name: 'Latency Checker', item_category: 'extra' },
    autorepair: { item_id: 'autorepair', item_name: 'Auto-Repair Tool', item_category: 'extra' },
    advancedbios: { item_id: 'advancedbios', item_name: 'Advanced BIOS Tweaking', item_category: 'extra' },
    windowsreinstall: { item_id: 'windowsreinstall', item_name: 'Windows Reinstall', item_category: 'extra' },
    support14days: { item_id: 'support14days', item_name: '14 Days Support', item_category: 'extra' }
  };

  function normalizeCurrency(value) {
    return String(value || 'USD').toUpperCase();
  }

  function isGaEnabled() {
    return /^G-[A-Z0-9]+$/i.test(GA_MEASUREMENT_ID) && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX';
  }

  function ensureGtag() {
    if (!isGaEnabled() || window.gtag) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_MEASUREMENT_ID);
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: true,
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }

  function track(eventName, params) {
    if (!isGaEnabled()) {
      return false;
    }
    ensureGtag();
    if (typeof window.gtag !== 'function') {
      return false;
    }
    window.gtag('event', eventName, params || {});
    return true;
  }

  function buildAnalyticsItem(itemId, price, quantity) {
    const base = PRODUCT_CATALOG[itemId] || {
      item_id: itemId,
      item_name: itemId,
      item_category: 'unknown'
    };

    const item = {
      item_id: base.item_id,
      item_name: base.item_name,
      item_category: base.item_category,
      quantity: quantity || 1
    };

    if (typeof price === 'number' && !Number.isNaN(price)) {
      item.price = Number(price.toFixed(2));
    }

    return item;
  }

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  window.salBuildAnalyticsItem = buildAnalyticsItem;
  window.salTrack = track;
  window.salTrackPackageSelection = function (packageId, source) {
    return track('select_item', {
      item_list_name: source || 'site',
      items: [buildAnalyticsItem(packageId)]
    });
  };
  window.salTrackViewCart = function (detail) {
    return track('view_cart', {
      currency: normalizeCurrency(detail && detail.currency),
      value: detail && typeof detail.value === 'number' ? Number(detail.value.toFixed(2)) : 0,
      items: detail && Array.isArray(detail.items) ? detail.items : []
    });
  };
  window.salTrackBeginCheckout = function (detail) {
    return track('begin_checkout', {
      currency: normalizeCurrency(detail && detail.currency),
      value: detail && typeof detail.value === 'number' ? Number(detail.value.toFixed(2)) : 0,
      items: detail && Array.isArray(detail.items) ? detail.items : []
    });
  };
  window.salTrackPurchase = function (detail) {
    return track('purchase', {
      transaction_id: detail && detail.transaction_id ? detail.transaction_id : 'unknown',
      currency: normalizeCurrency(detail && detail.currency),
      value: detail && typeof detail.value === 'number' ? Number(detail.value.toFixed(2)) : 0,
      items: detail && Array.isArray(detail.items) ? detail.items : []
    });
  };

  ensureGtag();

  document.addEventListener('click', function (event) {
    const element = event.target.closest('a,button');
    if (!element) {
      return;
    }

    const href = element.getAttribute('href') || '';
    const text = cleanText(element.innerText || element.textContent || element.getAttribute('aria-label') || element.title || element.id);
    let ctaType = 'generic';

    if (/discord\.gg/i.test(href)) {
      ctaType = 'discord';
    } else if (href.indexOf('checkout.html') !== -1) {
      ctaType = 'checkout_link';
    } else if (href.indexOf('packages.html') !== -1) {
      ctaType = 'packages';
    } else if (href.indexOf('contact.html') !== -1) {
      ctaType = 'contact';
    }

    track('cta_click', {
      cta_type: ctaType,
      cta_text: text || 'untitled',
      cta_target: cleanText(href || element.id || element.className || 'button'),
      page_path: window.location.pathname
    });
  }, { passive: true });

  (function consumePendingPurchase() {
    const currentPage = window.location.pathname.split('/').pop() || 'index.html';
    if (currentPage !== 'thankyou.html' && currentPage !== 'success.html') {
      return;
    }

    const raw = sessionStorage.getItem('sal_pending_purchase');
    if (!raw) {
      return;
    }

    try {
      const payload = JSON.parse(raw);
      if (!payload || !payload.transaction_id) {
        return;
      }

      const dedupeKey = 'sal_purchase_tracked_' + payload.transaction_id;
      if (sessionStorage.getItem(dedupeKey)) {
        return;
      }

      window.salTrackPurchase(payload);
      sessionStorage.setItem(dedupeKey, '1');
      sessionStorage.removeItem('sal_pending_purchase');
    } catch (error) {
      sessionStorage.removeItem('sal_pending_purchase');
    }
  })();
})();

/* ANIMATED BACKGROUND */
const canvas = document.getElementById('bg');
const ctx = canvas && typeof canvas.getContext === 'function' ? canvas.getContext('2d') : null;
let W;
let H;
let pts = [];
let gl = [];

function resize() {
  if (!canvas) {
    return;
  }
  W = canvas.width = innerWidth;
  H = canvas.height = innerHeight;
}

const rnd = (a, b) => Math.random() * (b - a) + a;

class Pt {
  constructor() {
    this.reset();
  }
  reset() {
    this.x = rnd(0, W || innerWidth);
    this.y = rnd(0, H || innerHeight);
    this.vx = rnd(-0.25, 0.25);
    this.vy = rnd(-0.42, -0.07);
    this.r = rnd(0.4, 1.6);
    this.a = rnd(0.18, 0.6);
    this.life = rnd(100, 250);
    this.age = 0;
    this.red = Math.random() > 0.65;
  }
  update() {
    this.x += this.vx;
    this.y += this.vy;
    this.age++;
    if (this.age > this.life || this.y < 0) {
      this.reset();
    }
  }
  draw() {
    if (!ctx) {
      return;
    }
    const alpha = this.a * (1 - this.age / this.life);
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.fillStyle = this.red ? `rgba(192,22,26,${alpha})` : `rgba(190,175,155,${alpha})`;
    ctx.fill();
  }
}

class GL {
  constructor(horizontal) {
    this.h = horizontal;
    this.reset();
  }
  reset() {
    if (this.h) {
      this.y = rnd(0, H || innerHeight);
      this.x = rnd(0, W || innerWidth);
      this.len = rnd(80, 300);
      this.spd = rnd(0.06, 0.25);
    } else {
      this.x = rnd(0, W || innerWidth);
      this.y = rnd(0, H || innerHeight);
      this.len = rnd(70, 240);
      this.spd = rnd(0.06, 0.22);
    }
    this.a = rnd(0.018, 0.085);
  }
  update() {
    if (this.h) {
      this.y += this.spd;
      if (this.y > H) {
        this.reset();
      }
    } else {
      this.x += this.spd;
      if (this.x > W) {
        this.reset();
      }
    }
  }
  draw() {
    if (!ctx) {
      return;
    }
    ctx.beginPath();
    if (this.h) {
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.x + this.len, this.y);
    } else {
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.x, this.y + this.len);
    }
    ctx.strokeStyle = `rgba(192,22,26,${this.a})`;
    ctx.lineWidth = 0.65;
    ctx.stroke();
  }
}

function initBackground() {
  if (!canvas || !ctx) {
    return;
  }
  resize();
  pts = Array.from({ length: 220 }, () => new Pt());
  gl = [
    ...Array.from({ length: 36 }, () => new GL(true)),
    ...Array.from({ length: 36 }, () => new GL(false))
  ];
  requestAnimationFrame(loopBackground);
}

function loopBackground() {
  if (!ctx) {
    return;
  }
  ctx.clearRect(0, 0, W, H);
  gl.forEach((line) => {
    line.update();
    line.draw();
  });
  pts.forEach((point) => {
    point.update();
    point.draw();
  });
  requestAnimationFrame(loopBackground);
}

if (canvas && ctx) {
  initBackground();
  window.addEventListener('resize', () => {
    resize();
    pts.forEach((point) => point.reset());
    gl.forEach((line) => line.reset());
  });
}

/* SCROLL REVEAL */
if ('IntersectionObserver' in window) {
  const obs = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  }), { threshold: 0.08 });

  document.querySelectorAll('.reveal').forEach((element) => obs.observe(element));

  /* COUNTER ANIMATION */
  function animateNum(el, target, suffix) {
    let current = 0;
    const step = Math.ceil(target / 60);
    const timer = setInterval(() => {
      current = Math.min(current + step, target);
      el.textContent = current + (suffix || '');
      if (current >= target) {
        clearInterval(timer);
      }
    }, 25);
  }

  const numObs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }
      entry.target.querySelectorAll('.cs-val').forEach((element) => {
        const text = element.textContent;
        if (text.includes('1,400')) {
          animateNum(element, 1400, '+');
        } else if (text.includes('100')) {
          animateNum(element, 100, '%');
        }
      });
      numObs.unobserve(entry.target);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.hero-card').forEach((element) => numObs.observe(element));
}

/* STICKY CTA */
const sticky = document.getElementById('sticky-cta');
if (sticky) {
  window.addEventListener('scroll', () => {
    sticky.classList.toggle('visible', scrollY > 600);
  }, { passive: true });
}

/* FAQ */
function faq(btn) {
  const item = btn.parentElement;
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach((element) => element.classList.remove('open'));
  if (!wasOpen) {
    item.classList.add('open');
  }
}
window.faq = faq;

/* MOBILE MENU */
let mo = false;
function toggleMenu() {
  mo = !mo;
  const links = document.querySelector('.nav-links');
  const ham = document.getElementById('ham-btn');
  if (!links) return;
  if (ham) ham.classList.toggle('open', mo);
  links.style.cssText = mo
    ? 'display:flex;flex-direction:column;position:fixed;top:90px;left:0;right:0;background:rgba(6,6,8,.97);padding:2rem 5vw;gap:1.5rem;border-bottom:1px solid rgba(192,22,26,.2);z-index:199'
    : '';
}
window.toggleMenu = toggleMenu;

document.querySelectorAll('.nav-links a').forEach((link) => link.addEventListener('click', () => {
  mo = false;
  const links = document.querySelector('.nav-links');
  const ham = document.getElementById('ham-btn');
  if (ham) ham.classList.remove('open');
  if (links) links.style.cssText = '';
}));

/* ACTIVE NAV LINK */
(function () {
  const path = window.location.pathname.replace(/\/$/, '').split('/').pop() || 'index';
  document.querySelectorAll('.nav-links a').forEach((link) => {
    const href = link.getAttribute('href').replace(/\.html$/, '').replace(/^.*\//, '');
    if (href === path || (path === 'index' && href === '/')) {
      link.classList.add('active');
    }
  });
})();

/* Dynamic nav offset from announce bar */
(function () {
  function fixNav() {
    const ann = document.getElementById('announce');
    const nav = document.querySelector('nav');
    if (ann && nav) {
      nav.style.top = ann.getBoundingClientRect().height + 'px';
    }
  }
  fixNav();
  window.addEventListener('resize', fixNav);
})();

/* DISCORD CHAT WIDGET */
function toggleChat() {
  const panel = document.getElementById('chat-panel');
  const dot = document.getElementById('chat-dot');
  if (!panel) {
    return;
  }
  panel.classList.toggle('open');
  if (dot) {
    dot.style.display = 'none';
  }
}
window.toggleChat = toggleChat;

setTimeout(function () {
  const bubble = document.getElementById('chat-bubble');
  const panel = document.getElementById('chat-panel');
  if (bubble && panel && !panel.classList.contains('open')) {
    bubble.style.animation = 'chatPulse 1.2s ease-in-out 3';
  }
}, 30000);

(function () {
  if (document.getElementById('chatPulseStyle')) {
    return;
  }
  const style = document.createElement('style');
  style.id = 'chatPulseStyle';
  style.textContent = '@keyframes chatPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.18)}}';
  document.head.appendChild(style);
})();
